
export function getLocalSettingsOrDefault(key, defaultVal) {
    const val = localStorage.getItem(key);

    if (typeof val == 'undefined' || val === null) return defaultVal;

    return JSON.parse(val);
}

export function setLocalSettings(key, val) {
    localStorage.setItem(key, JSON.stringify(val));
}


export function getLocalSettingsOrDefaultAutoObservable(key, defaultVal) {
    const obs = ko.observable(getLocalSettingsOrDefault(key, defaultVal));

    obs.subscribe((val) => {
        localStorage.setItem(key, JSON.stringify(val));
    });

    return obs;
}

export function getLocalSettingsOrDefaultAutoObservableArray(key, defaultVal) {
    const obs = ko.observableArray(getLocalSettingsOrDefault(key, defaultVal));

    obs.subscribe((val) => {
        localStorage.setItem(key, JSON.stringify(val));
    });

    return obs;
}